import { render, staticRenderFns } from "./GiftCardTicketBox.vue?vue&type=template&id=c5d72ca6&"
import script from "./GiftCardTicketBox.vue?vue&type=script&lang=js&"
export * from "./GiftCardTicketBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports